import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { CATEGORY_COLORS, getCategoryStyle } from "../lib/categoryStyle";

export default function ToolCard({ tool }) {
    const color = CATEGORY_COLORS[tool.category] || "primary";
    const style = getCategoryStyle(color);

    return (
        <Link
            to={`/tool/${tool.slug}`}
            data-testid={`tool-card-${tool.slug}`}
            className="group relative bg-white border-2 border-black rounded-2xl p-5 transition-all nb-shadow hover:-translate-y-1 hover:shadow-[8px_8px_0px_#0A0A0A] flex flex-col gap-3 h-full"
        >
            <div className="flex items-start justify-between gap-3">
                <span
                    className={`${style.bg} ${style.text} nb-border text-[10px] font-bold uppercase tracking-widest px-2.5 py-1 rounded-full`}
                >
                    {tool.category.replace(/-/g, " ")}
                </span>
                <div className="w-8 h-8 rounded-full nb-border bg-white flex items-center justify-center group-hover:bg-black group-hover:text-white transition-colors">
                    <ArrowUpRight strokeWidth={2.5} className="w-4 h-4" />
                </div>
            </div>

            <div className="font-display text-xl md:text-2xl font-extrabold leading-tight">
                {tool.name}
            </div>
            <p className="text-sm text-neutral-700 flex-1">{tool.description}</p>

            <div className="pt-1 text-xs font-bold uppercase tracking-widest text-neutral-600">
                Free · Unlimited
            </div>
        </Link>
    );
}
